__webpack_require__.p = "/patent-search/";